import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "@/firebase";

export const createAuthLog = async ({
  action,
  user = null,
  email = "",
  message,
}) => {
  try {
    await addDoc(collection(db, "auth_logs"), {
      action,
      user_id: user?.uid || null,
      email: email || user?.email || "",
      user_role: user?.role || "unknown",
      message,
      user_agent: navigator.userAgent,
      created_at: serverTimestamp(),
    });
  } catch (err) {
    console.error("Auth log error:", err);
  }
};
